@if (state.config.betsConfig.winner) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Winning Team ({{ state.config.betsConfig.winner.points }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.winner"
                               [key]="'winner'"
                               [options]="state.winnerOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.exactScore) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Exact Score ({{ state.config.betsConfig.exactScore.points }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.exactScoreOptions"
                            [initValue]="state.betting?.exactScore"
                            [key]="'exactScore'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.underOver) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Total number of goals during the match ({{ state.config.betsConfig.underOver.points }})
      </mat-card-title>
      <mat-card-subtitle>Under/Over</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.underOver"
                               [key]="'underOver'"
                               [options]="state.underOverOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.goalsDiff) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Goals differance ({{ state.config.betsConfig.goalsDiff.points }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.goalsDiffOptions"
                            [initValue]="state.betting?.goalsDiff"
                            [key]="'goalsDiff'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.numOfCorners) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Number of corners ({{ state.config.betsConfig.numOfCorners.points }})</mat-card-title>
      <mat-card-subtitle>Under/Over</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.numberOfCornersOptions"
                            [initValue]="state.betting?.numOfCorners"
                            [key]="'numOfCorners'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.gameDuration) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Match duration ({{ state.config.betsConfig.gameDuration.points }})</mat-card-title>
      <mat-card-subtitle>Under/Over</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.matchDurationOptions"
                            [initValue]="state.betting?.gameDuration"
                            [key]="'gameDuration'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.firstTeamToScore) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>First team to score ({{ state.config.betsConfig.firstTeamToScore.points }})</mat-card-title>
      <mat-card-subtitle>Under/Over</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.firstTeamToScore"
                               [key]="'firstTeamToScore'"
                               [options]="state.firstTeamToScoreOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.firstTeamToScore) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>First team to receive a card ({{ state.config.betsConfig.firstTeamToScore.points }})
      </mat-card-title>
      <mat-card-subtitle>Yellow or red</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.firstTeamToGetCard"
                               [key]="'firstTeamToGetCard'"
                               [options]="state.firstTeamToGetCardOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.numberOfCards) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Number of cards ({{ state.config.betsConfig.numberOfCards.points }})</mat-card-title>
      <mat-card-subtitle>Yellow or red</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.numberOfCardsOptions"
                            [initValue]="state.betting?.numberOfCards"
                            [key]="'numberOfCards'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.firstTeamToHaveCorner) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>First team to receive a corner ({{ state.config.betsConfig.firstTeamToHaveCorner.points }})
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.firstTeamToHaveCorner"
                               [key]="'firstTeamToHaveCorner'"
                               [options]="state.firstTeamToHaveCornerOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}
